export default "__VITE_ASSET__D9w9M4A4__"